import React, { useEffect } from "react";
import "./Snackbar.css";

const Snackbar = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onClose]);

  const getMessageType = (msg) => {
    if (typeof msg === "string") {
      const successCount = (msg.match(/Successfully processed rows:/g) || [])
        .length;
      const failedCount = (msg.match(/Failed rows:/g) || []).length;

      if (successCount > 0 && failedCount > 0) {
        return "info"; // Blue for mixed results
      } else if (successCount > 0) {
        return "success"; // Green for success
      } else if (failedCount > 0) {
        return "error"; // Red for failure
      }
    }
    return type;
  };

  const formatMessage = (msg) => {
    if (typeof msg === "string") {
      const successCount = (msg.match(/Successfully processed rows:/g) || [])
        .length;
      const failedCount = (msg.match(/Failed rows:/g) || []).length;

      if (successCount > 0 && failedCount > 0) {
        return `Successfully inserted ${successCount} rows, ${failedCount} rows failed`;
      } else if (successCount > 0) {
        return `Successfully inserted ${successCount} rows`;
      } else if (failedCount > 0) {
        return `${failedCount} rows failed to import`;
      }
    }
    return msg;
  };

  return (
    <div className={`snackbar ${getMessageType(message)}`}>
      <div className="snackbar-content">
        <span>{formatMessage(message)}</span>
        <button
          onClick={onClose}
          style={{
            background: "none",
            border: "none",
            color: "white",
            cursor: "pointer",
            fontSize: "20px",
            padding: "0 5px",
          }}
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default Snackbar;
